import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import ReferralCapture from "@/components/ReferralCapture";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import ProductDetailPage from "@/pages/ProductDetailPage";
import CoursesPage from "@/pages/CoursesPage";
import AllCoursesPage from "@/pages/AllCoursesPage";
import ForexMadeSimplePage from "@/pages/ForexMadeSimplePage";
import IntermediatePage from "@/pages/IntermediatePage";
import AdvancedPage from "@/pages/AdvancedPage";
import RiskDisclaimerPage from "@/pages/RiskDisclaimerPage";
import MyCoursesPage from "@/pages/MyCoursesPage";
import CourseDeliveryPage from "@/pages/CourseDeliveryPage";
import AdminCoursesPage from "@/pages/AdminCoursesPage";
import IndicatorsPage from "@/pages/IndicatorsPage";
import CartPage from "@/pages/CartPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import AffiliatePage from "@/pages/AffiliatePage";
import PaymentSuccessPage from "@/pages/PaymentSuccessPage";
import ReviewsPage from "@/pages/ReviewsPage";
import ContactPage from "@/pages/ContactPage";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="min-h-screen bg-[#050814] text-white flex flex-col overflow-x-hidden w-full max-w-[100vw]">
            <Header />
            <ScrollToTop />
            <ReferralCapture />
            <main>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/products/:slug" element={<ProductDetailPage />} />
                <Route path="/courses" element={<CoursesPage />} />
                <Route path="/all-courses" element={<AllCoursesPage />} />
                <Route path="/forex-made-simple" element={<ForexMadeSimplePage />} />
                <Route path="/intermediate" element={<IntermediatePage />} />
                <Route path="/advanced" element={<AdvancedPage />} />
                <Route path="/indicators" element={<IndicatorsPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/affiliate" element={<AffiliatePage />} />
                <Route path="/payment-success" element={<PaymentSuccessPage />} />
                <Route path="/reviews" element={<ReviewsPage />} />
                <Route path="/beginner" element={<Navigate to="/forex-made-simple" replace />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/risk-disclaimer" element={<RiskDisclaimerPage />} />
                <Route path="/my-courses" element={<MyCoursesPage />} />
                <Route path="/my-courses/:slug" element={<CourseDeliveryPage />} />
                <Route path="/admin/courses" element={<AdminCoursesPage />} />
              </Routes>
            </main>
            <Footer />
          </div>
          <Toaster position="bottom-center" theme="dark" richColors closeButton />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
